<template>
  <div>
    <Wysiwyg v-model="textarea" />
  </div>
</template>

<script>
import Wysiwyg from "@/components/Wysiwyg";
import templateHTML from "@/utils/supplierTemplateHTML";

export default {
  components: {
    Wysiwyg,
  },
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    banner: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    textarea: {
      get() {
        return this.сutTextarea(this.value);
      },
      set(val) {
        this.$emit(
          "input",
          this.replaceTemplate(val, this.title, this.extensionBanner)
        );
      },
    },
    extensionBanner() {
      if (typeof this.banner === "string") {
        const regexp = this.banner.match(/\.(jpe?g|png)$/i);

        return regexp ? regexp[1] : "png";
      }
      return "png";
    },
  },
  watch: {
    banner() {
      this.$emit(
        "input",
        this.replaceTemplate(this.textarea, this.title, this.extensionBanner)
      );
    },
  },
  methods: {
    replaceTemplate(text, title, extension) {
      return templateHTML
        .replace("{{TEXTAREA}}", text)
        .replace("{{EXTENSION}}", extension)
        .replace(/{{TITLE}}/g, title)
        .trim();
    },
    сutTextarea(val) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(val, "text/html");
      const div = doc.getElementsByTagName("div");

      if (div[1]) {
        // textarea в шаблоне во втором div от body
        return div[1].innerHTML;
      }
      return "";
    },
  },
};
</script>
